import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import styles from './post-like.module.scss';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { WCircularProgress } from '../../wrappers/wrapper';
import InfiniteScroll from 'react-infinite-scroll-component';
import { IPaginate, TLike, TUser } from '../../../models/common';
import dbService from '../../../services/database.service';
import useDeviceType from 'custom-hooks/useDeviceType';

interface PostLikeProps {
  id: string;
  onClick: (id: string) => void;
  onClose: () => void;
}

function PostLike({ id, onClick, onClose }: PostLikeProps) {
  const { isMobile } = useDeviceType();
  const [total, setTotal] = useState(0);
  const [likes, setLikes] = useState<TLike[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [skip, setSkip] = useState(0);
  const limit = 11;

  useEffect(() => {
    getLikes();
  }, []);

  const getLikes = async () => {
    const result = await dbService
      .getLikes({
        filter: { article: id },
        limit,
        skip,
        paginate: true,
        relation: true,
      })
      .then((res) => res as unknown as IPaginate<TLike>);

    setSkip((prevSkip) => prevSkip + limit);

    if (result.data.length === 0) {
      setHasMore(false);
      return;
    }

    setLikes((prevLikes) => [...prevLikes, ...result.data]);

    if (!total) {
      setTotal(result.meta.total);
    }
  };

  const renderLoading = () => (
    <div className={styles.loading}>
      <WCircularProgress size={20} />
    </div>
  );

  const getHeight = () => {
    if (isMobile) {
      return window.screen.height - 100;
    }
    return likes.length > 5 ? 320 : likes.length * 55;
  };

  return (
    <div className={styles['post-like']}>
      {!!likes.length ? (
        <>
          <div className={styles['header']}>
            <span>{!!total && `${total} Likes`}</span>
            <div onClick={onClose} className={styles.closeButton}>
              <CloseIcon />
            </div>
          </div>
          <InfiniteScroll
            dataLength={likes.length}
            next={getLikes}
            hasMore={hasMore}
            loader={renderLoading()}
            height={getHeight()}
            className={styles.container}
          >
            {likes?.map((like, i) => (
              <div onClick={() => onClick((like.user as TUser)._id!)} key={i}>
                <ProfilePhoto user={like.user} radius="100%" width="2.5rem" height="2.5rem" />
                <span className={styles.username}>{(like.user as TUser).username}</span>
              </div>
            ))}
          </InfiniteScroll>
        </>
      ) : (
        renderLoading()
      )}
    </div>
  );
}
export default PostLike;
